export default __webpack_public_path__ + "static/media/01d.85d9b43b.svg";